import type { TranslationTable } from "@repo/shared/types";

const EN_GB = {
  savingInflow: "Saving Inflow / Year",
  fromPlans: (n: string) => `From ${n} active savings plans`,
  fromPlansOne: "From 1 active savings plan",
};

// All 17 locales (QL-17 plan keeps them); the type makes each one match EN_GB.
export const T: TranslationTable<typeof EN_GB> = {
  en_GB: EN_GB,
  fr_FR: {
    savingInflow: "Épargne / an",
    fromPlans: (n) => `Issue de ${n} plans d'épargne actifs`,
    fromPlansOne: "Issue d'1 plan d'épargne actif",
  },
  es_ES: {
    savingInflow: "Ahorro / año",
    fromPlans: (n) => `De ${n} planes de ahorro activos`,
    fromPlansOne: "De 1 plan de ahorro activo",
  },
  pt_BR: {
    savingInflow: "Aportes / ano",
    fromPlans: (n) => `De ${n} planos de aportes ativos`,
    fromPlansOne: "De 1 plano de aportes ativo",
  },
  de_DE: {
    savingInflow: "Sparzuflüsse / Jahr",
    fromPlans: (n) => `Aus ${n} aktiven Sparplänen`,
    fromPlansOne: "Aus 1 aktiven Sparplan",
  },
  it_IT: {
    savingInflow: "Flussi di risparmio / anno",
    fromPlans: (n) => `Da ${n} piani di accumulo attivi`,
    fromPlansOne: "Da 1 piano di accumulo attivo",
  },
  ar: {
    savingInflow: "تدفقات الادخار / سنة",
    fromPlans: (n) => `من ${n} خطط ادخار نشطة`,
    fromPlansOne: "من خطة ادخار نشطة واحدة",
  },
  ja_JP: {
    savingInflow: "積立流入額／年",
    fromPlans: (n) => `有効な積立プラン ${n} 件から`,
    fromPlansOne: "有効な積立プラン 1 件から",
  },
  hi_IN: {
    savingInflow: "बचत अंतर्वाह / वर्ष",
    fromPlans: (n) => `${n} सक्रिय बचत योजनाओं से`,
    fromPlansOne: "1 सक्रिय बचत योजना से",
  },
  zh_CN: {
    savingInflow: "定投流入 / 年",
    fromPlans: (n) => `来自 ${n} 个有效定投计划`,
    fromPlansOne: "来自 1 个有效定投计划",
  },
  zh_TW: {
    savingInflow: "定期定額流入 / 年",
    fromPlans: (n) => `來自 ${n} 個有效的定期定額計畫`,
    fromPlansOne: "來自 1 個有效的定期定額計畫",
  },
  nl_NL: {
    savingInflow: "Spaarinleg / jaar",
    fromPlans: (n) => `Uit ${n} actieve spaarplannen`,
    fromPlansOne: "Uit 1 actief spaarplan",
  },
  nb_NO: {
    savingInflow: "Sparing / år",
    fromPlans: (n) => `Fra ${n} aktive spareavtaler`,
    fromPlansOne: "Fra 1 aktiv spareavtale",
  },
  sv_SE: {
    savingInflow: "Sparande / år",
    fromPlans: (n) => `Från ${n} aktiva sparavtal`,
    fromPlansOne: "Från 1 aktivt sparavtal",
  },
  fi_FI: {
    savingInflow: "Säästöt / vuosi",
    fromPlans: (n) => `${n} aktiivisesta säästösopimuksesta`,
    fromPlansOne: "1 aktiivisesta säästösopimuksesta",
  },
  da_DK: {
    savingInflow: "Opsparing / år",
    fromPlans: (n) => `Fra ${n} aktive opsparingsaftaler`,
    fromPlansOne: "Fra 1 aktiv opsparingsaftale",
  },
  is_IS: {
    savingInflow: "Sparnaður / ár",
    fromPlans: (n) => `Frá ${n} virkum sparnaðarsamningum`,
    fromPlansOne: "Frá 1 virkum sparnaðarsamningi",
  },
};
